import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';

import applicationUserManager from "../Auth/applicationusermanager";

//let base = '';
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理

export const base = process.env.NODE_ENV == "production" ? 'https://shopapi.koipy.com' : '';
// 请求延时
axios.defaults.timeout = 20000

var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

        if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }

        saveRefreshtime();

        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // 超时请求处理
        var originalRequest = error.config;
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {

            Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });

            originalRequest._retry = true
            return null;
        }

        if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({
                        token: window.localStorage.Token
                    }).then((res) => {
                        if (res.success) {
                            store.commit("saveToken", res.response.token);

                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expires_in));
                            store.commit("saveTokenExpire", expiredate);

                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                }

            }
            // 403 无权限
            if (error.response.status == 403) {
                Vue.prototype.$message({
                    message: '失败！该操作无权限',
                    type: 'error'
                });
                return null;
            }
            // 429 ip限流
            if (error.response.status == 429) {
                Vue.prototype.$message({
                    message: '刷新次数过多，请稍事休息重试！',
                    type: 'error'
                });
                return null;
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);


export const BaseApiUrl = base;

// 登录
export const requestLogin = params => {
    return axios.get(`${base}/admin/login/GetJwtToken`, {
        params: params
    }).then(res => res.data);
};
export const requestLoginMock = params => {
    return axios.post(`${base}/login`, params).then(res => res.data);
};

export const refreshToken = params => {
    return axios.get(`${base}/admin/login/RefreshToken`, {
        params: params
    }).then(res => res.data);
};

export const saveRefreshtime = params => {

    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

    let refreshCount = 1; //滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};
const ToLogin = params => {

    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');



    if (global.IS_IDS4) {
        applicationUserManager.login();
    } else {
        router.replace({
            path: "/login",
            query: {
                redirect: router.currentRoute.fullPath
            }
        });

        window.location.reload()
    }
};

export const getUserByToken = params => {
    return axios.get(`${base}/admin/adminUser/getInfoByToken`, {
        params: params
    }).then(res => res.data);
};

// 用户管理
export const getUserListPage = params => {
    return axios.get(`${base}/admin/adminUser/get`, {
        params: params
    });
};
export const removeUser = params => {
    return axios.delete(`${base}/admin/adminUser/delete`, {
        params: params
    });
};
export const editUser = params => {
    return axios.put(`${base}/admin/adminUser/put`, params);
};
export const addUser = params => {
    return axios.post(`${base}/admin/adminUser/post`, params);
};
export const editUserInfo = params => {
    return axios.put(`${base}/admin/AdminUser/putinfo`, params);
};
export const loadPass = params => {
    return axios.get(`${base}/admin/AdminUser/loadPass`, {
        params: params
    });
};
export const getUserInfoById = params => {
    return axios.get(`${base}/admin/General/getUserInfo`, {
        params: params
    });
};
// 角色管理
export const getRoleListPage = params => {
    return axios.get(`${base}/admin/adminRole/get`, {
        params: params
    });
};
export const removeRole = params => {
    return axios.delete(`${base}/admin/adminRole/delete`, {
        params: params
    });
};
export const editRole = params => {
    return axios.put(`${base}/admin/adminRole/put`, params);
};
export const addRole = params => {
    return axios.post(`${base}/admin/adminRole/post`, params);
};

// 接口模块管理
export const getModuleAllListPage = params => {
    return axios.get(`${base}/admin/module/getall`, {
        params: params
    });
};
export const getModuleListPage = params => {
    return axios.get(`${base}/admin/module/get`, {
        params: params
    });
};
export const removeModule = params => {
    return axios.delete(`${base}/admin/module/delete`, {
        params: params
    });
};
export const editModule = params => {
    return axios.put(`${base}/admin/module/put`, params);
};
export const addModule = params => {
    return axios.post(`${base}/admin/module/post`, params);
};

// 菜单模块管理
export const getPermissionListPage = params => {
    return axios.get(`${base}/admin/permission/get`, {
        params: params
    });
};
export const getPermissionTreeTable = params => {
    return axios.get(`${base}/admin/permission/GetTreeTable`, {
        params: params
    });
};
export const removePermission = params => {
    return axios.delete(`${base}/admin/permission/delete`, {
        params: params
    });
};
export const editPermission = params => {
    return axios.put(`${base}/admin/permission/put`, params);
};
export const addPermission = params => {
    return axios.post(`${base}/admin/permission/post`, params);
};
export const getPermissionTree = params => {
    return axios.get(`${base}/admin/permission/getpermissiontree`, {
        params: params
    });
};
export const getPermissionIds = params => {
    return axios.get(`${base}/admin/permission/GetPermissionIdByRoleId`, {
        params: params
    });
};

export const addRolePermission = params => {
    return axios.post(`${base}/admin/permission/Assign`, params);
};
export const getNavigationBar = params => {
    return axios.get(`${base}/admin/permission/GetNavigationBar`, {
        params: params
    }).then(res => res.data);
};

// 日志
export const getLogs = params => {
    return axios.get(`${base}/admin/Monitor/get`, {
        params: params
    });
};
export const getRequestApiinfoByWeek = params => {
    return axios.get(`${base}/admin/Monitor/GetRequestApiinfoByWeek`, {
        params: params
    });
};
export const getAccessApiByDate = params => {
    return axios.get(`${base}/admin/Monitor/GetAccessApiByDate`, {
        params: params
    });
};
export const getAccessApiByHour = params => {
    return axios.get(`${base}/admin/Monitor/GetAccessApiByHour`, {
        params: params
    });
};
export const getAccessLogs = params => {
    return axios.get(`${base}/admin/Monitor/GetAccessLogs`, {
        params: params
    });
};
export const getServerInfo = params => {
    return axios.get(`${base}/admin/Monitor/Server`, {
        params: params
    });
};
export const getActiveUsers = params => {
    return axios.get(`${base}/admin/Monitor/GetActiveUsers`, {
        params: params
    });
};


// 地区管理
export const getAreaListPage = params => {
    return axios.get(`${base}/admin/Area/get`, {
        params: params
    });
};
export const getAreaAllList = () => {
    return axios.get(`${base}/admin/Area/GetAllList`);
};
export const removeArea = params => {
    return axios.delete(`${base}/admin/Area/delete`, {
        params: params
    });
};
export const editArea = params => {
    return axios.put(`${base}/admin/Area/put`, params);
};
export const addArea = params => {
    return axios.post(`${base}/admin/Area/post`, params);
};
//商户管理
export const getLocation = (params) => {
    return axios.get(`${base}/admin/Shop/GetLocation`, {
        params: params
    });
};
export const getShopBasis = (params) => {
    return axios.get(`${base}/admin/Shop/GetBasis`, {
        params: params
    });
};
export const getByEid = (params) => {
    return axios.get(`${base}/admin/Shop/GetByEid`, {
        params: params
    });
};
export const getShopListPage = params => {
    return axios.get(`${base}/admin/Shop/get`, {
        params: params
    });
};
export const getShopList = params => {
    return axios.get(`${base}/admin/TourDiy/GetShopList`, {
        params: params
    });
};
export const getShopListByIds = params => {
    return axios.get(`${base}/admin/Shop/GetShopListByIds`, {
        params: params
    });
};
export const removeShop = params => {
    return axios.delete(`${base}/admin/Shop/delete`, {
        params: params
    });
};
export const editShop = params => {
    return axios.put(`${base}/admin/Shop/put`, params);
};
export const addShop = params => {
    return axios.post(`${base}/admin/Shop/post`, params);
};
export const shopResetWeight = () => {
    return axios.get(`${base}/admin/Shop/ResetWeight`);
};
export const verifyBusinessId = params => {
    return axios.get(`${base}/admin/Shop/verifyBusinessId`, {
        params: params
    });
};

// 商户产品管理

export const searchProduct = (params) => {
    return axios.get(`${base}/admin/Product/SearchProduct`, {
        params: params
    });
};
export const getProductBasis = (params) => {
    return axios.get(`${base}/admin/Product/GetBasis`, {
        params: params
    });
};
export const getProductListPage = params => {
    return axios.get(`${base}/admin/Product/get`, {
        params: params
    });
};
export const removeProduct = params => {
    return axios.delete(`${base}/admin/Product/delete`, {
        params: params
    });
};
export const editProduct = params => {
    return axios.put(`${base}/admin/Product/put`, params);
};
export const addProduct = params => {
    return axios.post(`${base}/admin/Product/post`, params);
};
export const importProductdata = (params, excelFile, imgList) => {
    const formData = new FormData();
    Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
    });
    excelFile.forEach(file => {
        formData.append('excelFile', file.raw, file.raw.name);
    });
    imgList.forEach(file => {
        formData.append('imgFiles', file.raw, file.raw.name);
    })
    return axios.post(`${base}/admin/Product/importdata`, formData);
};
export const openProductEnabled = params => {
    return axios.put(`${base}/admin/Product/openEnabled`, params);
};
export const updateProductTarget = params => {
    return axios.put(`${base}/admin/Product/updateTarget`, params);
};

//产品类型管理
export const getProductTypeListPage = params => {
    return axios.get(`${base}/admin/ProductType/get`, {
        params: params
    });
};
export const removeProductType = params => {
    return axios.delete(`${base}/admin/ProductType/delete`, {
        params: params
    });
};
export const editProductType = params => {
    return axios.put(`${base}/admin/ProductType/put`, params);
};
export const addProductType = params => {
    return axios.post(`${base}/admin/ProductType/post`, params);
};

//文件
export const getShopFileList = params => {
    return axios.get(`${base}/admin/ShopFiles/GetFileById`, {
        params: params
    });
};
export const deleteShopFile = params => {
    return axios.delete(`${base}/admin/ShopFiles/delete`, {
        params: params
    });
};
export const replaceShopCover = params => {
    return axios.get(`${base}/admin/ShopFiles/replaceCover`, {
        params: params
    });
};
// 配送时段
export const getShippingTimeList = params => {
    return axios.get(`${base}/admin/ShippingTime/get`, {
        params: params
    });
};
export const removeShippingTime = params => {
    return axios.delete(`${base}/admin/ShippingTime/delete`, {
        params: params
    });
};
export const editShippingTime = params => {
    return axios.put(`${base}/admin/ShippingTime/put`, params);
};
export const addShippingTime = params => {
    return axios.post(`${base}/admin/ShippingTime/post`, params);
};
export const addAllShippingTime = params => {
    return axios.post(`${base}/admin/ShippingTime/postall`, params);
};
// 商户类型
export const getShopTypeListPage = params => {
    return axios.get(`${base}/admin/ShopType/get`, {
        params: params
    });
};
export const getShopTypeAllList = () => {
    return axios.get(`${base}/admin/ShopType/GetAllList`);
};
export const removeShopType = params => {
    return axios.delete(`${base}/admin/ShopType/delete`, {
        params: params
    });
};
export const editShopType = params => {
    return axios.put(`${base}/admin/ShopType/put`, params);
};
export const addShopType = params => {
    return axios.post(`${base}/admin/ShopType/post`, params);
};
//商户Banner管理
export const getShopBannerListPage = params => {
    return axios.get(`${base}/admin/Banner/get`, {
        params: params
    });
};
export const removeShopBanner = params => {
    return axios.delete(`${base}/admin/Banner/delete`, {
        params: params
    });
};
export const editShopBanner = params => {
    return axios.put(`${base}/admin/Banner/put`, params);
};
export const addShopBanner = params => {
    return axios.post(`${base}/admin/Banner/post`, params);
};
//产品规格管理
export const getProductSpecTypeListPage = params => {
    return axios.get(`${base}/admin/ProductSpecType/get`, {
        params: params
    });
};
export const removeProductSpecType = params => {
    return axios.delete(`${base}/admin/ProductSpecType/delete`, {
        params: params
    });
};
export const editProductSpecType = params => {
    return axios.put(`${base}/admin/ProductSpecType/put`, params);
};
export const addProductSpecType = params => {
    return axios.post(`${base}/admin/ProductSpecType/post`, params);
};
export const addAllProductSpecType = params => {
    return axios.post(`${base}/admin/ProductSpecType/PostAll`, params);
};
export const getProductSpecListPage = params => {
    return axios.get(`${base}/admin/ProductSpec/get`, {
        params: params
    });
};
export const removeProductSpec = params => {
    return axios.delete(`${base}/admin/ProductSpec/delete`, {
        params: params
    });
};
export const editProductSpec = params => {
    return axios.put(`${base}/admin/ProductSpec/put`, params);
};
export const addProductSpec = params => {
    return axios.post(`${base}/admin/ProductSpec/post`, params);
};
//订单管理
export const getAllOrderListPage = params => {
    return axios.post(`${base}/admin/Order/GetAllOrderList`, params);
};
export const getShopOrderListPage = params => {
    return axios.post(`${base}/admin/Order/GetShopOrderList`, params);
};
export const editOrder = params => {
    return axios.put(`${base}/admin/Order/put`, params);
};
export const getShippingTime = params => {
    return axios.get(`${base}/admin/Order/GetShippingTime`, {
        params: params
    });
};
export const getOrderItem = params => {
    return axios.get(`${base}/admin/Order/GetOrderItem`, {
        params: params
    });
};
export const addOrderItem = params => {
    return axios.post(`${base}/admin/Order/postItem`, params);
};

export const editOrderItem = params => {
    return axios.put(`${base}/admin/Order/putItem`, params);
};
export const editStatus = params => {
    return axios.put(`${base}/admin/Order/putStatus`, params);
};
export const editAllStatus = params => {
    return axios.put(`${base}/admin/Order/putAllStatus`, params);
};
export const removeOrderItem = params => {
    return axios.delete(`${base}/admin/Order/deleteItem`, {
        params: params
    });
};
export const getOrderItemProduct = params => {
    return axios.get(`${base}/admin/Product/GetOrderItemProduct`, {
        params: params
    });
};
export const updateOrderTotal = params => {
    return axios.get(`${base}/admin/Order/putOrderTotal`, {
        params: params
    });
};
export const getOrderExportShops = params => {
    return axios.get(`${base}/admin/Order/exportShops`, {
        responseType: 'blob',
        params: params
    });
};
export const getOrderExportTeam = params => {
    return axios.get(`${base}/admin/Order/exportTeam`, {
        responseType: 'blob',
        params: params
    });
};
export const getAllOrderExportShops = params => {
    return axios.get(`${base}/admin/Order/exportAllShops`, {
        responseType: 'blob',
        params: params
    });
};
export const getAllOrderExportTeam = params => {
    return axios.get(`${base}/admin/Order/exportAllTeam`, {
        responseType: 'blob',
        params: params
    });
};
export const getAllExportSalesDetail = params => {
    return axios.get(`${base}/admin/Order/exportAllSalesDetail`, {
        responseType: 'blob',
        params: params
    });
};
export const getShopStatistics = params => {
    return axios.get(`${base}/admin/Order/GetShopStatistics`, {
        params: params
    });
};
export const getExportShopOrder = params => {
    return axios.get(`${base}/admin/Order/exportShopOrder`, {
        responseType: 'blob',
        params: params
    });
};
export const getSalesDetailList = params => {
    return axios.get(`${base}/admin/Order/getSalesDetailList`, {
        params: params
    });
};
export const getOrderNumberTotal = params => {
    return axios.get(`${base}/admin/Order/getOrderNumberTotal`, {
        params: params
    });
};
//商户标签管理
export const getShopLabelList = params => {
    return axios.get(`${base}/admin/ShopLabel/Get`, {
        params: params
    });
};
export const removeShopLabel = params => {
    return axios.delete(`${base}/admin/ShopLabel/delete`, {
        params: params
    });
};
export const editShopLabel = params => {
    return axios.put(`${base}/admin/ShopLabel/put`, params);
};
export const addShopLabel = params => {
    return axios.post(`${base}/admin/ShopLabel/post`, params);
};
//用户储值
export const refundOrder = params => {
    return axios.post(`${base}/admin/UserTransaction/refundOrder`, params);
};
export const getUserTransactionList = params => {
    return axios.get(`${base}/admin/UserTransaction/Get`, {
        params: params
    });
};
export const updateUserAmount = params => {
    return axios.post(`${base}/admin/UserTransaction/updateUserAmount`, params);
};
export const getKoipyUserInfo = params => {
    return axios.get(`${base}/admin/General/getUserInfoByPhone`, {
        params: params
    });
};
//拼单管理
export const getTourDiyConfigList = params => {
    return axios.get(`${base}/admin/TourDiyConfig/Get`, {
        params: params
    });
};
export const removeTourDiyConfig = params => {
    return axios.delete(`${base}/admin/TourDiyConfig/delete`, {
        params: params
    });
};
export const editTourDiyConfig = params => {
    return axios.put(`${base}/admin/TourDiyConfig/put`, params);
};
export const addTourDiyConfig = params => {
    return axios.post(`${base}/admin/TourDiyConfig/post`, params);
};
export const addAllTourDiyConfig = params => {
    return axios.post(`${base}/admin/TourDiyConfig/PostAll`, params);
};
//商户满减管理
export const getShopDerateList = params => {
    return axios.get(`${base}/admin/ShopDerate/Get`, {
        params: params
    });
};
export const removeShopDerate = params => {
    return axios.delete(`${base}/admin/ShopDerate/delete`, {
        params: params
    });
};
export const editShopDerate = params => {
    return axios.put(`${base}/admin/ShopDerate/put`, params);
};
export const addShopDerate = params => {
    return axios.post(`${base}/admin/ShopDerate/post`, params);
};
//拼单管理
export const GetTourDiyShopUrl = params => {
    return axios.get(`${base}/admin/TourDiy/GetTourDiyShopUrl`, {
        params: params
    });
};
export const getUnconfirmedList = params => {
    return axios.get(`${base}/admin/TourDiy/GetUnconfirmedList`, {
        params: params
    });
};
export const sendBusinessRemind = params => {
    return axios.get(`${base}/admin/TourDiy/sendBusinessRemind`, {
        params: params
    });
};
export const getTourDiyList = params => {
    return axios.get(`${base}/admin/TourDiy/Get`, {
        params: params
    });
};
export const getTourDiyByShopList = params => {
    return axios.get(`${base}/admin/ShopTourDiy/Get`, {
        params: params
    });
};
export const getTourDiyOrderList = params => {
    return axios.get(`${base}/admin/ShopTourDiy/GetTourOrderList`, {
        params: params
    });
};
export const tourDiyAffirmReceipt = params => {
    return axios.get(`${base}/admin/ShopTourDiy/AffirmReceipt`, {
        params: params
    });
};
export const tourDiyGetInfo = params => {
    return axios.get(`${base}/admin/ShopTourDiy/GetShopInfo`, {
        params: params
    });
};
export const tourDiyAffirmAllReceipt = params => {
    return axios.post(`${base}/admin/ShopTourDiy/AffirmAllReceipt`, params);
};
export const tourDiyExportData = params => {
    return axios.get(`${base}/admin/ShopTourDiy/TourDiyExportData`, {
        responseType: 'blob',
        params: params
    });
};
export const tourDiyExportAllData = params => {
    return axios.post(`${base}/admin/ShopTourDiy/TourDiyExportAllData`, params, {
        responseType: 'blob'
    });
};

export const getShippingList = params => {
    return axios.get(`${base}/admin/TourDiy/GetShopShipping`, {
        params: params
    });
};

export const addTourDiy = params => {
    return axios.post(`${base}/admin/TourDiy/post`, params);
};

export const getDummyList = params => {
    return axios.get(`${base}/admin/TourDiy/GetDummyList`, {
        params: params
    });
};
export const addTourDiyDummy = params => {
    return axios.get(`${base}/admin/TourDiy/AddTourDiyDummy`, {
        params: params
    });
};
export const removeTourDiyDummy = params => {
    return axios.delete(`${base}/admin/TourDiy/DeleteDummy`, {
        params: params
    });
};


//小程序配置
export const getMiniConifg = () => {
    return axios.get(`${base}/admin/Shop/GetMiniConifg`);
};
export const editMiniConifg = params => {
    return axios.put(`${base}/admin/Shop/editMiniConifg`, params);
};
//储值相关
export const getRecordList = params => {
    return axios.get(`${base}/admin/Recharge/GetRecordList`, {
        params: params
    });
};
export const getRechargeConfigList = () => {
    return axios.get(`${base}/admin/Recharge/GetRechargeConfigList`);
};
export const removeRechargeConfig = params => {
    return axios.delete(`${base}/admin/Recharge/delete`, {
        params: params
    });
};
export const editRechargeConfig = params => {
    return axios.put(`${base}/admin/Recharge/put`, params);
};
export const addRechargeConfig = params => {
    return axios.post(`${base}/admin/Recharge/post`, params);
};
export const editRechargeStatus = params => {
    return axios.get(`${base}/admin/Recharge/EditStatus`, {
        params: params
    });
};
//品牌配置
export const getBusinessConfigList = params => {
    return axios.get(`${base}/admin/BusinessConfig/Get`, {
        params: params
    });
};
export const getBusinessConfigListByIds = params => {
    return axios.get(`${base}/admin/BusinessConfig/GetListByIds`, {
        params: params
    });
};
export const removeBusinessConfig = params => {
    return axios.delete(`${base}/admin/BusinessConfig/delete`, {
        params: params
    });
};
export const editBusinessConfig = params => {
    return axios.put(`${base}/admin/BusinessConfig/put`, params);
};
export const addBusinessConfig = params => {
    return axios.post(`${base}/admin/BusinessConfig/post`, params);
};

//日期任务
export const getShopDateEventList = params => {
    return axios.get(`${base}/admin/ShopDateEvent/Get`, {
        params: params
    });
};
export const removeShopDateEvent = params => {
    return axios.delete(`${base}/admin/ShopDateEvent/delete`, {
        params: params
    });
};
export const editShopDateEvent = params => {
    return axios.put(`${base}/admin/ShopDateEvent/put`, params);
};
export const addShopDateEvent = params => {
    return axios.post(`${base}/admin/ShopDateEvent/post`, params);
};
//主题活动
export const getThemeActivityList = params => {
    return axios.get(`${base}/admin/ThemeActivity/Get`, {
        params: params
    });
};
export const removeThemeActivity = params => {
    return axios.delete(`${base}/admin/ThemeActivity/delete`, {
        params: params
    });
};
export const editThemeActivity = params => {
    return axios.put(`${base}/admin/ThemeActivity/put`, params);
};
export const addThemeActivity = params => {
    return axios.post(`${base}/admin/ThemeActivity/post`, params);
};
//配送管理
export const getExpressList = params => {
    return axios.get(`${base}/admin/Express/Get`, {
        params: params
    });
};
//商户收支
export const getCashFlowList = params => {
    return axios.get(`${base}/admin/CashFlow/Get`, {
        params: params
    });
};
export const addCashFlow = params => {
    return axios.post(`${base}/admin/CashFlow/post`, params);
};
//商户首单奖励管理
export const getShopFirstDerateList = params => {
    return axios.get(`${base}/admin/ShopFirstDerate/Get`, {
        params: params
    });
};
export const removeShopFirstDerate = params => {
    return axios.delete(`${base}/admin/ShopFirstDerate/delete`, {
        params: params
    });
};
export const editShopFirstDerate = params => {
    return axios.put(`${base}/admin/ShopFirstDerate/put`, params);
};
export const addShopFirstDerate = params => {
    return axios.post(`${base}/admin/ShopFirstDerate/post`, params);
};
//商户提款审核
export const getShopPayoutList = params => {
    return axios.get(`${base}/admin/ShopPayout/Get`, {
        params: params
    });
};
export const shopPayoutApprove = params => {
    return axios.get(`${base}/admin/ShopPayout/Approve`, {
        params: params
    });
};
export const shopPayoutRefused = params => {
    return axios.get(`${base}/admin/ShopPayout/Refused`, {
        params: params
    });
};